import React from 'react'
import { observer } from 'mobx-react'
import Button from 'components/Button'
import ScopeChangeRequestDetailsViewModel from '../ScopeChangeRequestDetailsViewModel'
import link from 'infra/link'
import { Id } from 'types/definitions'
import styles from './DetailsFooter.sass'
import {
  NotificationBar,
  NotificationBarTitle,
  NotificationBarSubtitle,
} from 'components/NotificationBar'

interface DetailsFooterProps {
  vm: ScopeChangeRequestDetailsViewModel
}

export default observer(function DetailsFooter({ vm }: DetailsFooterProps) {
  return (
    <div className={styles.footer}>
      {!vm.scopeChangeRequest.isPendingClientApproval && (
        <JobClosedNotificationBar showing={vm.isJobClosed} />
      )}
      <div className={styles.buttonGroupContainer}>
        <Button
          target="_blank"
          to={link.job(Id.assert(vm.scopeChangeRequest.job.id))}
        >
          View Job
        </Button>
        {vm.canResolveScopeChangeRequest &&
          !vm.scopeChangeRequest.isResolved && (
            <div className={styles.requestActions}>
              {(vm.scopeChangeRequest.isPendingFinalization ||
                vm.scopeChangeRequest.isPendingAdminApproval) && (
                <Button
                  dataTest="scope-change-request-decline"
                  onClick={vm.decline}
                >
                  Decline
                </Button>
              )}
              {vm.scopeChangeRequest.isPendingFinalization && (
                <Button
                  dataTest="scope-change-request-finalize"
                  onClick={vm.finalize}
                  type="primary"
                  loading={vm.finalize.pending}
                  disabled={vm.finalize.pending || vm.isJobClosed}
                >
                  Finalize
                </Button>
              )}
              {vm.scopeChangeRequest.isPendingAdminApproval && (
                <Button
                  dataTest="scope-change-request-admin-approve"
                  onClick={vm.adminApprove}
                  type="primary"
                  loading={vm.adminApprove.pending}
                  disabled={vm.adminApprove.pending || vm.isJobClosed}
                >
                  Accept
                </Button>
              )}
              {vm.scopeChangeRequest.isPendingClientApproval && (
                <Button
                  dataTest="scope-change-request-resolve"
                  onClick={vm.resolve}
                  type="primary"
                >
                  Resolve
                </Button>
              )}
            </div>
          )}
      </div>
    </div>
  )
})

interface JobClosedNotificationBarProps {
  showing: boolean
}

export const JobClosedNotificationBar = observer(
  ({ showing }: JobClosedNotificationBarProps) => {
    if (!showing) {
      return
    }

    return (
      <NotificationBar centered type="error">
        <NotificationBarTitle>Unable to accept request:</NotificationBarTitle>
        <NotificationBarSubtitle>Job is already closed</NotificationBarSubtitle>
      </NotificationBar>
    )
  },
)
